export enum Icons {
  hot = 'personal-area-icon__hot',
  pin = 'personal-area-icon__pin',
  lock = 'personal-area-icon__lock',
  phone = 'personal-area-icon__phone',
  envelope = 'personal-area-icon__envelope',
  headerEnvelope = 'header__envelope',
  faq = 'personal-area-icon__faq',
  hotlink = 'personal-area-icon__hotlink',
  star = 'personal-area-icon__star',
  qa = 'personal-area-icon__qa',
  fav = 'personal-area-icon__fav',
  bell = 'personal-area-icon__bell',
  home = 'home',
  homePlus = 'home-plus',
  avatar = 'avatar',
  burgerDots = 'burger-dots',
  sign = 'sign',
  cross = 'cross',
  crossSmall = 'cross-small',
  crossBold = 'cross-bold',
  replies = 'replies',
  spinner = 'spinner',
  location = 'location',
  checkmark = 'checkmark',
  link = 'link',
  circlePlus = 'circle-plus',
  circleAdd = 'circle-add',
  pencil = 'pencil',
  pencilFilled = 'pencil-filled',
  search = 'search',
  searchBlue = 'search-blue',
  menu = 'menu',
  hotLoader = 'hot-loader',
  carretBack = 'carret-back',
  carretDown = 'carret-down',
  phoneSmall = 'phone-small',
  accordionCarret = 'accordion-carret',
  circleCross = 'circle-cross',
  dots = 'dots',
  notFound = 'not-found',
  questionCircle = 'question-circle',
  infoCircle = 'info-circle',
  warningBox = 'warning-box',
  infoCircleNew = 'info-circle-new',
  pride = 'pride',
  notificationBell = 'notification-bell',
  check = 'check',
  send = 'send',
  dollarBox = 'dollar-box',

  socialFacebook = 'social-facebook',
  // socialTwitter = 'social-twitter',
  socialInstagram = 'social-instagram',
  socialLoyalfans = 'social-loyalfans',
  socialTelegram = 'social-telegram',
  socialTer = 'social-ter',
  socialTiktok = 'social-tiktok',
  socialTransfans = 'social-transfans',
  socialWhatsapp = 'social-whatsapp',
  socialWechat = 'social-wechat',
  socialLine = 'social-line',
  socialTumblr = 'social-tumblr',
  socialOnlyfans = 'social-onlyfans',

  mediaCross = 'media-cross',
  mediaPlay = 'media-play',
  plus = 'plus',

  socialEditLine = 'social-edit-line',
  socialEditTumblr = 'social-edit-tumblr',
  socialEditWhatsapp = 'social-edit-whatsapp',
  socialEditFacebook = 'social-edit-facebook',
  socialEditInstagram = 'social-edit-instagram',
  socialEditTelegram = 'social-edit-telegram',
  socialEditWeechat = 'social-edit-weechat',
  // socialEditOnlyfans = 'social-edit-onlyfans',
  // socialEditTer = 'social-edit-ter',

  trash = 'trash', // old and probably deprecated
  trashbin = 'tashbin', // new one trash icon
  // used in Notification modal
  delete = 'delete',

  // hamburger-menu
  accountSettings = 'account-settings',
  advertiseOnHot = 'advertise-on-hot',
  adStatistic = 'ad-statistic',
  addBusiness = 'add-business',
  adsDashboard = 'ads-dashboard',
  changeEmail = 'change-email',
  changePassword = 'change-password',
  changePhone = 'change-phone',
  changePinCode = 'change-pin-code',
  editHotlinksPage = 'edit-hotlinks-page',
  generalInvoice = 'general-invoice',
  logout = 'logout',
  menuFaq = 'menu-faq',
  myAccount = 'my-account',
  myAds = 'my-ads',
  myHotlinks = 'my-hotlinks',
  myMailbox = 'my-mailbox',
  myNotifications = 'my-notifications',
  myQa = 'my-qa',
  myReviews = 'my-reviews',
  myFavorites = 'my-favorites',
  paidInvoices = 'paid-invoices',
  payInvoices = 'pay-invoices',
  postAd = 'post-ad',
  postMobileMenuAd = 'post-mobile-menu-ad',
  postTextAd = 'post-text-ad',
  promoteImages = 'promote-images',
  promoteUrl = 'promote-url',
  setUpBitcoinAddress = 'set-up-bitcoin-address',
  subscribers = 'subscribers',
  transactions = 'transactions',
  carretRight = 'carret-right',
  carretLeft = 'carret-left',
  clear = 'clear',
  photo = 'photo',
  dragndrop = 'dragndrop',
  searchPhoto = 'search-photo',

  // logo
  hotlinksLogo = 'hotlinks-logo',

  // Guest Menu
  guestAddBusinessBold = 'guest-add-business-bold',
  guestAddBusiness = 'guest-add-business',
  guestAdvertise = 'guest-advertise',
  guestFaqBold = 'guest-faq-bold',
  guestSignInBold = 'guest-sign-in',
  guestSignUpBold = 'guest-sign-up',

  // Form
  formRadio = 'form-radio',
  formRadioChecked = 'form-radio-checked',

  formCheckbox = 'form-checkbox',
  formCheckboxChecked = 'form-checkbox-checked',
  formCheckboxPartial = 'form-checkbox-partial',

  // Import api
  importApiDoc = 'import-api-doc',
  importApiMail = 'import-api-mail',
  importApiCopy = 'import-api-copy',
  importApiCopyThin = 'import-api-copy-thin',
  importApiClock = 'import-api-clock',
  importApiSearch = 'import-api-search',
  importApiEye = 'import-api-eye',
  importApiRefresh = 'import-api-refresh',
  importApiEyeClose = 'import-api-eye-close',
  ImportApiProfilesSearch = 'import-api-profiles-search',
  ImportApiExternalLink = 'import-api-external-link',
  ImportApiHistory = 'import-api-history',
  ImportApiInfo = 'import-api-info',
}

export enum PromotionIcons {
  promoBoost = 'promo-boost',
  promoImage = 'promo-image',
  promoMenu = 'promo-menu',
  promoText = 'promo-text',
  promoTopspot = 'promo-topspot',
  promoUrl = 'promo-url',
}

export enum SidebarIcons {
  dashboard = 'dashboard',
  faq = 'faq',
  funds = 'funds',
  favorites = 'favorites',
  impportApi = 'import-api',
  invoiceGenerate = 'invoice-generate',
  invoicePaid = 'invoice-paid',
  invoicePay = 'invoice-pay',
  logout = 'sidebar-logout',
  myQuestions = 'sidebar-my-qa',
  myReviews = 'sidebar-my-reviews',
  myHotlinks = 'sidebar-my-hotlinks',
  settings = 'settings',
  statistics = 'statistics',
  transactions = 'sidebar-transactions',
  businessList = 'business-list',
  businessClaim = 'business-claim',
  connectedProfiles = 'sidebar-connected-profiles',
}

export enum FooterIcons {
  Location = 'footer-location',
  LocationPrecise = 'footer-location-precise',
  SocialTelegram = 'footer-social-telegram',
  SocialYoutube = 'footer-social-youtube',
  SocialTiktok = 'footer-social-tiktok',
  SocialInstagram = 'footer-social-instagram',
  SocialFacebook = 'footer-social-facebook',
  SocialX = 'footer-social-x',
}

export enum BottomNavIcons {
  Search = 'bottom-nav-search',
  Cams = 'bottom-nav-cams',
  Dating = 'bottom-nav-dating',
  Support = 'bottom-nav-support',
}

export type IconType = Icons | SidebarIcons | PromotionIcons | FooterIcons | BottomNavIcons;

export enum NotificationIcons {
  success = 'notifications-success',
  error = 'notifications-error',
  info = 'notifications-info',
  warning = 'notifications-warning',
}

export type IconName = Icons | PromotionIcons | SidebarIcons | NotificationIcons;

export enum MenuIcons {
  connectedProfiles = 'menu-connected-profiles',
}

export enum UIKitIcons {
  phone = 'ui-phone',
  question = 'ui-question',
  review = 'ui-review',
  warmUp = 'ui-warm-up',
  cellPhone = 'ui-cell-phone',
  messageStar = 'ui-message-star',
}

export type AnyIcon =
  | Icons
  | SidebarIcons
  | UIKitIcons
  | PromotionIcons
  | MenuIcons
  | FooterIcons
  | BottomNavIcons
  | NotificationIcons;

export interface IconProps {
  name: AnyIcon;
  className?: string;
  onClick?: (event: any) => void;
  width?: number;
  height?: number;
  color?: string;
}

export type LoaderIconProps = Omit<IconProps, 'name'>;
